export default () => {
  const route = useRoute();

  // reactive now: paginated pages get the noindex hint as soon as `?page`
  // appears, not only when the component first sets up
  useHead(() => ({
    meta: route.query.page
      ? [{ name: 'robots', content: 'noindex, follow' }]
      : [],
  }));
};
